export { DetailPageHeader } from "./DetailPageHeader";
